import cNav from './components/nav'
import cModals from './components/copyModal'
import responsivePage from './components/responsive'

import "../scss/app.scss"

const initScripts = {
  init: function () {
    cNav()
    responsivePage()
    cModals()
  },
}
initScripts.init()
